import { createLucideIcon } from "lucide-react";

export const Menu1 = createLucideIcon(
    "Menu1",
    [
        [
            "path",
            {
                d: "M4 12L20 12",
                key: "1pco2j",
            },
        ],
        [
            "path",
            {
                d: "M4 19L20 19",
                key: "2yky4t",
            },
        ],
        [
            "path",
            {
                d: "M4 5L20 5",
                key: "1tsob7",
            },
        ],
    ],
);
